export const ComponentTypes = {
  APPOINTMENT_BOOKING: 'appointment-booking',
  AUTO_COMPLETE: 'auto-complete',
  CHECKBOXES: 'checkboxes',
  CLIENT_API: 'client-api',
  DATEPICKER: 'datepicker',
  GOOGLE_ADDRESS: 'google-address',
  HIDDEN: 'hidden',
  HINT: 'hint',
  HTML: 'html',
  LOADER: 'loader',
  NAVIGATION_CONTROL: 'navigation-control',
  NEWSLETTER_SIGNUP: 'newsletter-signup',
  RADIOS: 'radios',
  SELECT: 'select',
  SELECT_AND_CONNECT: 'select-and-connect',
  SUPPLIER_CARD: 'supplier-card',
  SUPPLIER_MATCH: 'supplier-match',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  TEXTFIELD: 'textfield',
};

export const ComponentTypesToReceiveFocusOnPageEnter = [
  ComponentTypes.TEXTFIELD,
  ComponentTypes.GOOGLE_ADDRESS,
];

export const ComponentsWithoutCustomerInput = [
  ComponentTypes.HIDDEN,
  ComponentTypes.HINT,
  ComponentTypes.HTML,
  ComponentTypes.LOADER,
  ComponentTypes.NAVIGATION_CONTROL,
  ComponentTypes.SUPPLIER_CARD,
  ComponentTypes.TEXT,
];

export const GenericAdmiralFields = {
  FIRST_NAME: 'first_name',
  YOUR_FIRST_NAME: 'your_first_name',
  LAST_NAME: 'last_name',
  PHONE_HOME: 'phone_home',
  PHONE_MOBILE: 'phone_mobile',
  PHONE_WORK: 'phone_work',
  PHONE_FAX: 'phone_fax',
  PHONE_OFFICE: 'phone_office',
  MOBILE_NUMBER: 'mobile_number',
  COMPANY_NAME: 'company_name',
  POSTCODE: 'postcode',
  PRIMARY_ADDRESS_POSTCODE: 'primary_address_postalcode',
  PRIMARY_ADDRESS_STREET: 'primary_address_street',
  PRIMARY_ADDRESS_STATE: 'primary_address_state',
  PRIMARY_ADDRESS_CITY: 'primary_address_city',
  EMAIL: 'email1',
  COUNTRY: 'country',
};

export const PhoneNumberFields = [
  GenericAdmiralFields.PHONE_HOME,
  GenericAdmiralFields.PHONE_MOBILE,
  GenericAdmiralFields.PHONE_WORK,
  GenericAdmiralFields.PHONE_FAX,
  GenericAdmiralFields.PHONE_OFFICE,
  GenericAdmiralFields.MOBILE_NUMBER,
];

export const FREE_TEXT_COMPONENTS = [
  ComponentTypes.AUTO_COMPLETE,
  ComponentTypes.GOOGLE_ADDRESS,
  ComponentTypes.TEXTAREA,
  ComponentTypes.TEXTFIELD,
];
